
import { state } from "@/store/modules/encaste/insemination/state";
import mutations from "@/store/modules/encaste/insemination/mutations"
import actions from "@/store/modules/encaste/insemination/actions"
import getters from "@/store/modules/encaste/insemination/getters"

/** @returns { import('vuex').Module } */
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}